import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

function NewsCard({ article }) {
  return (
    <>
      <Card className="news__card">
        <CardMedia
          image={`https://nytimes.com/${article.multimedia[0].url}`}
          title={article.headline.main}
          height="200"
          component="img"
        />
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {article.headline.main}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {article.lead_paragraph.substring(0, 50)} . . .
          </Typography>
          <Typography variant="caption" color="textSecondary" component="p">
            {article.pub_date}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" color="primary" href={article.web_url}>
            Learn More
          </Button>
        </CardActions>
      </Card>
    </>
  );
}

export default NewsCard;
